<div class="work-popup edit-modal modal-dialog">
  <div class="modal-content">
      <div class="name_icon">
        <div class="name-icon-title">
          <div class="add-content-text-container">
            <p class="add-content-text">Edit Content</p>
          </div>
          <div class="close-add-content-popup">
            <mat-icon (click)="closePopUp()" class="close-icon-edit-content-admin">close</mat-icon>
          </div>
        </div>
      </div>
    <div class="edit-content-container">
      <form [formGroup]="contentForm" (ngSubmit)="onSubmit()" class="edit-content">
          <div class="form-group padding-bottom-custom">
            <input class="form-control" type="text" tabindex="-1" formControlName="name" placeholder="Name"
                   [ngClass]="{'has-error': editContentControl['name'].invalid && editContentControl['name'].touched}">
            <div *ngIf="editContentControl['name'].invalid && editContentControl['name'].touched" class="validation">
              <small *ngIf="editContentControl['name'].errors!['required'] || editContentControl['name'].errors!['whitespace'] ">Name is required</small>
              <small *ngIf="editContentControl['name'].errors!['minlength']">Name should be at least 2
                characters</small>
              <small *ngIf="editContentControl['name'].errors!['maxlength']">Name cannot exceed 20 characters</small>
            </div>
          </div>
          <div class="form-group padding-bottom-custom-8">
            <mat-form-field appearance="fill">
              <mat-select placeholder="Content Type" tabindex="-1" formControlName="contentType" required>
                <mat-option *ngFor="let platformType of getPlatformTypes()" [value]="platformType">
                  {{platformType}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div *ngIf="editContentControl['contentType'].invalid && editContentControl['contentType'].touched"
                 class="validation platform-type-valid-message">
              <small *ngIf="editContentControl['contentType'].errors!['required']">Platform Type is required</small>
              <small *ngIf="editContentControl['contentType'].errors!['invalidPlatformType']">
                Please select a valid Platform Type
              </small>
            </div>
          </div>

          <div *ngIf="!showFileInput" class="form-group">
              <div class="img-wrap">
                <img *ngIf="!selectedFile"
                     [src]="getContentIcon(contentResponse?.contentIcon)"
                     alt="Image">
                <img *ngIf="selectedFile"
                     [src]="getImageAsSource(selectedFile)"
                     alt="Image">
                <div class="delete-img-content-add">
                  <mat-icon (click)="imageShow()" class="close-content-icon">close</mat-icon>
                </div>
            </div>
          </div>
          <div class="col-12 icon-show">
            <div class="form-group change-icon">
              <input tabindex="-1" *ngIf="showFileInput" #contentIcon class="form-control"
                     type="file" id="imageInput"
                     [accept]="getAcceptFileType()" (change)="showImages($event)">
                <div class="validation">
                    <small *ngIf="fileSizeExceeded" >File size should not exceed 2MB</small>
                    <small *ngIf="showError">Image is required</small>
                </div>
            </div>
          </div>
        <div class="buttons-container-admin">
          <div class="buttons-side w-100">
            <button mat-button class="save-btn" type="submit" (click)="onSubmit()">Save</button>
            <button mat-button class="cancel-btn" type="button" (click)="closePopUp()">Cancel</button>
          </div>
        </div>
        </form>
      </div>
    </div>
</div>
